import { Action } from '@ngrx/store';
import * as QuoteCaptureActions from './../actions/response-quote-datacapture.actions';

export type Actions = QuoteCaptureActions.Actions;

export function QuoteCaptureReducer(state = [], action: QuoteCaptureActions.Actions) {
    switch (action.type) {
        case QuoteCaptureActions.ADD_QUOTE_CAPTURE:
            return [...state, action.payload];

        // Add this case:
        case QuoteCaptureActions.REMOVE_QUOTE_CAPTURE:
            state = [];
            return state;

        default:
            return state;
    }
}
